import { createTheme } from '@mantine/core';
import { mantineColors } from './mantine-colors';

export const mantineTheme = createTheme({
  colors: mantineColors,
});
